var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "w-row",
        { attrs: { "no-margin": "" } },
        [
          _c(
            "w-col",
            { attrs: { md: "6", "no-margin": "", xs: "12" } },
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c(
                        "app-page-settings-default",
                        {
                          model: {
                            value: _vm.layout.PageSettings,
                            callback: function ($$v) {
                              _vm.$set(_vm.layout, "PageSettings", $$v)
                            },
                            expression: "layout.PageSettings",
                          },
                        },
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-checkbox", {
                                attrs: {
                                  value:
                                    _vm.layout.PageSettings
                                      .ShowHeaderOnlyOnFirstPage,
                                  label: _vm.$ct(
                                    "show-header-only-on-first-page"
                                  ),
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.setShowHeaderOnlyOnFirstPage(
                                      $event
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-checkbox", {
                                attrs: {
                                  value:
                                    !_vm.layout.PageSettings
                                      .DontPushTotalsToBottomOfPage,
                                  label: _vm.$ct(
                                    "push-totals-to-bottom-of-page"
                                  ),
                                },
                                on: {
                                  input: function ($event) {
                                    _vm.layout.PageSettings.DontPushTotalsToBottomOfPage =
                                      !$event
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c(
                                "w-row",
                                [
                                  _c("w-checkbox", {
                                    attrs: {
                                      value:
                                        _vm.layout.PageNumberSettings
                                          .AlwaysShow,
                                      label: _vm.$ct("page-number-show"),
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.layout.PageNumberSettings.AlwaysShow =
                                          $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-row",
                                {
                                  attrs: { "no-margin": "", "no-padding": "" },
                                },
                                [
                                  _c("w-select", {
                                    staticClass: "mr",
                                    style: { flexGrow: 1 },
                                    attrs: {
                                      items: _vm.pageNumberLocations,
                                      fancy: "",
                                      label: _vm.$ct("page-numbers"),
                                    },
                                    model: {
                                      value:
                                        _vm.layout.PageNumberSettings.Location,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.layout.PageNumberSettings,
                                          "Location",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "layout.PageNumberSettings.Location",
                                    },
                                  }),
                                  _c(
                                    "w-button",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: _vm.$ct("edit-style"),
                                          expression: "$ct('edit-style')",
                                        },
                                      ],
                                      on: {
                                        click: function ($event) {
                                          _vm.editPageNumberStyleOpen = true
                                        },
                                      },
                                    },
                                    [_c("w-fa", { attrs: { icon: "font" } })],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-checkbox", {
                                attrs: { label: _vm.$ct("split-detail-rows") },
                                model: {
                                  value:
                                    _vm.layout.PageSettings.SplitDetailRows,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.layout.PageSettings,
                                      "SplitDetailRows",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "layout.PageSettings.SplitDetailRows",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.isSupport
                            ? _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-checkbox", {
                                    attrs: {
                                      disabled:
                                        !_vm.layout.PageSettings
                                          .SplitDetailRows,
                                      label: _vm.$ct("avoid-split-detail-rows"),
                                    },
                                    model: {
                                      value:
                                        _vm.layout.PageSettings
                                          .PreferNotToSplitDetailRows,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.layout.PageSettings,
                                          "PreferNotToSplitDetailRows",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "layout.PageSettings.PreferNotToSplitDetailRows",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _vm.isSupport
                                ? _c("w-select", {
                                    attrs: {
                                      items: _vm.pdfEngineItems,
                                      label: _vm.$ct("pdf-engine"),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.layout.UseChromium,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.layout, "UseChromium", $$v)
                                      },
                                      expression: "layout.UseChromium",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm.isSupport
                            ? _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      fancy: "",
                                      min: 0,
                                      max: 1,
                                      label: _vm.$ct("layout-engine-version"),
                                      decimals: 0,
                                    },
                                    model: {
                                      value: _vm.layout.LayoutVersion,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.layout,
                                          "LayoutVersion",
                                          $$v
                                        )
                                      },
                                      expression: "layout.LayoutVersion",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-default-language", {
                        model: {
                          value: _vm.layout.PageSettings,
                          callback: function ($$v) {
                            _vm.$set(_vm.layout, "PageSettings", $$v)
                          },
                          expression: "layout.PageSettings",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { md: "6", "no-margin": "", xs: "12" } },
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-page-settings-background-image", {
                        model: {
                          value: _vm.layout.PageSettings,
                          callback: function ($$v) {
                            _vm.$set(_vm.layout, "PageSettings", $$v)
                          },
                          expression: "layout.PageSettings",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                { attrs: { grow: "" } },
                [
                  _c(
                    "w-col",
                    { attrs: { grow: "", xs: "12" } },
                    [
                      _c("app-page-settings-font", {
                        staticClass: "grow",
                        model: {
                          value: _vm.layout.PageSettings,
                          callback: function ($$v) {
                            _vm.$set(_vm.layout, "PageSettings", $$v)
                          },
                          expression: "layout.PageSettings",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-custom-css", {
                    model: {
                      value: _vm.layout.PageSettings,
                      callback: function ($$v) {
                        _vm.$set(_vm.layout, "PageSettings", $$v)
                      },
                      expression: "layout.PageSettings",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("app-margin-edit", {
                attrs: { title: _vm.$ct("footer-margin") },
                model: {
                  value: _vm.layout.FootMargin,
                  callback: function ($$v) {
                    _vm.$set(_vm.layout, "FootMargin", $$v)
                  },
                  expression: "layout.FootMargin",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-card",
                [
                  _c("w-card-title", [
                    _vm._v(_vm._s(_vm.$ct("download-name"))),
                  ]),
                  _c(
                    "w-card-content",
                    [
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-input", {
                                ref: "input",
                                attrs: {
                                  label: _vm.$ct("file-name"),
                                  fancy: "",
                                },
                                model: {
                                  value: _vm.layout.FileName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.layout, "FileName", $$v)
                                  },
                                  expression: "layout.FileName",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c(
                                "w-row",
                                { attrs: { "no-margin": "" } },
                                [
                                  _c("app-prop-select-autocomplete", {
                                    style: { flexGrow: 1, flexShrink: 1 },
                                    attrs: {
                                      up: "",
                                      items: _vm.fileNameProperties,
                                      label: _vm.$ct("file-name-property-add"),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.selectedFileNameProp,
                                      callback: function ($$v) {
                                        _vm.selectedFileNameProp = $$v
                                      },
                                      expression: "selectedFileNameProp",
                                    },
                                  }),
                                  _c(
                                    "w-button",
                                    {
                                      staticClass: "ml",
                                      style: { flexShrink: 0 },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addFileNameProp()
                                        },
                                      },
                                    },
                                    [_c("w-fa", { attrs: { icon: "plus" } })],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { style: { flexDirection: "row" }, attrs: { xs: "12" } },
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel mt",
                  on: {
                    click: function ($event) {
                      return _vm.reset()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("reset-to-defaults")) + " ")]
              ),
              _c("w-spacer"),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.editPageNumberStyleOpen } },
        [
          _vm.editPageNumberStyleOpen
            ? _c("app-style-editor", {
                attrs: { "preview-text": "1/3" },
                on: {
                  close: function ($event) {
                    _vm.editPageNumberStyleOpen = false
                  },
                },
                model: {
                  value: _vm.layout.PageNumberSettings.Style,
                  callback: function ($$v) {
                    _vm.$set(_vm.layout.PageNumberSettings, "Style", $$v)
                  },
                  expression: "layout.PageNumberSettings.Style",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }